module.exports = __webpack_public_path__ + "static/img/LOGO_xinfu.3239854.png";